(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["crown-ingredients"] && !Shopify.designMode) return;
  try {
    
(function () {
  var AUTO_MS = 4500;    // auto-advance interval (Momentum-style ~4-5s)
  var RESUME_MS = 5000;  // resume auto-rotate this long after a manual interaction
  var DRAG_FRAC = 0.18;  // fraction of a card's width a drag must exceed to advance

  function activateReveals(scope) {
    scope.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('is-in'); });
  }

  function initCarousel(root) {
    if (root.dataset.cInit) return;
    root.dataset.cInit = '1';

    var viewport = root.querySelector('.crown-ing__viewport');
    var track    = root.querySelector('.crown-ing__track');
    var dots     = Array.prototype.slice.call(root.querySelectorAll('.crown-ing__dot'));
    var prev     = root.querySelector('[data-c-prev]');
    var next     = root.querySelector('[data-c-next]');
    var playBtn  = root.querySelector('[data-c-play]');
    if (!viewport || !track) return;

    var reals = Array.prototype.slice.call(track.querySelectorAll('.crown-ing__card'));
    var N = reals.length;
    if (!N) return;

    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // Clone a full set BEFORE and AFTER the reals so the loop is seamless and the
    // peeking side-cards always match across the wrap (the row is fully periodic).
    var before = document.createDocumentFragment();
    var after  = document.createDocumentFragment();
    reals.forEach(function (c) {
      var b = c.cloneNode(true); b.classList.add('crown-ing__card--clone'); b.setAttribute('aria-hidden', 'true');
      var a = c.cloneNode(true); a.classList.add('crown-ing__card--clone'); a.setAttribute('aria-hidden', 'true');
      before.appendChild(b);
      after.appendChild(a);
    });
    track.insertBefore(before, track.firstChild);
    track.appendChild(after);

    var cards = Array.prototype.slice.call(track.querySelectorAll('.crown-ing__card'));
    var BASE = N;         // index of the first real card within `cards`
    var pos  = BASE;      // index of the currently-centred card
    var cardW = 0, step = 0;

    // offsetWidth / offsetLeft ignore the CSS transform (scale), so they give the
    // true layout geometry regardless of the centre-emphasis scaling.
    function measure() {
      cardW = cards[0].offsetWidth;
      step  = cards[1] ? (cards[1].offsetLeft - cards[0].offsetLeft) : cardW;
    }
    function translateFor(p) { return (viewport.clientWidth - cardW) / 2 - p * step; }
    function realIndex() { return ((pos - BASE) % N + N) % N; }
    function markCentre() { cards.forEach(function (c, i) { c.classList.toggle('is-center', i === pos); }); }
    function syncDots() {
      var ri = realIndex();
      dots.forEach(function (d, i) { d.setAttribute('aria-current', i === ri ? 'true' : 'false'); });
    }
    function paint() {
      track.style.transform = 'translate3d(' + translateFor(pos) + 'px,0,0)';
      markCentre(); syncDots();
    }
    function animateTo(p) { track.style.transition = ''; pos = p; paint(); }
    function jumpTo(p) {                    // reposition with NO animation
      track.style.transition = 'none';
      pos = p; paint();
      track.offsetHeight;                   // force reflow so later moves animate
      track.style.transition = '';
    }
    // After a move lands on a clone, silently jump one full set back into the real
    // band — invisible because the sets are identical (this is the seamless wrap).
    function settle() {
      if (pos < BASE) jumpTo(pos + N);
      else if (pos >= BASE + N) jumpTo(pos - N);
    }
    function go(dir) { animateTo(pos + dir); if (reduce) requestAnimationFrame(settle); }

    track.addEventListener('transitionend', function (e) {
      if (e.target === track && e.propertyName === 'transform') settle();
    });

    // ---- autoplay + pause/play ----
    var timer = null, resumeT = null, userPaused = false;
    function playing() { return timer !== null; }
    function setIcon() {
      if (!playBtn) return;
      playBtn.setAttribute('aria-pressed', playing() ? 'false' : 'true');
      playBtn.setAttribute('aria-label', playing() ? 'Pause automatic rotation' : 'Play automatic rotation');
    }
    function start(immediate) {
      if (reduce || userPaused || timer) { setIcon(); return; }
      if (immediate) go(1);                 // resume-after-interaction: advance right away
      timer = setInterval(function () { go(1); }, AUTO_MS);
      setIcon();
    }
    function halt() { if (timer) { clearInterval(timer); timer = null; } setIcon(); }
    function bump() {                       // manual interaction: pause now, resume later
      halt();
      clearTimeout(resumeT);
      if (!userPaused && !reduce) resumeT = setTimeout(function () { start(true); }, RESUME_MS);
    }
    function nav(dir) { bump(); go(dir); }

    if (playBtn) playBtn.addEventListener('click', function () {
      userPaused = !userPaused;
      clearTimeout(resumeT);
      if (userPaused) halt(); else start();
    });
    if (prev) prev.addEventListener('click', function () { nav(-1); });
    if (next) next.addEventListener('click', function () { nav(1); });
    dots.forEach(function (d, i) { d.addEventListener('click', function () { bump(); animateTo(BASE + i); }); });
    viewport.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); nav(1); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); nav(-1); }
    });

    // ---- drag / swipe ----
    var dragging = false, startX = 0, baseT = 0, moved = 0, pid = null;
    viewport.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      dragging = true; moved = 0; startX = e.clientX; baseT = translateFor(pos); pid = e.pointerId;
      bump();
      track.style.transition = 'none';
      try { viewport.setPointerCapture(pid); } catch (err) {}
    });
    viewport.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      moved = e.clientX - startX;
      track.style.transform = 'translate3d(' + (baseT + moved) + 'px,0,0)';
    });
    function endDrag() {
      if (!dragging) return;
      dragging = false;
      try { if (pid !== null) viewport.releasePointerCapture(pid); } catch (err) {}
      track.style.transition = '';
      var thresh = cardW * DRAG_FRAC;
      if (moved <= -thresh) go(1);
      else if (moved >= thresh) go(-1);
      else animateTo(pos);                  // not far enough — snap back
      bump();
    }
    viewport.addEventListener('pointerup', endDrag);
    viewport.addEventListener('pointercancel', endDrag);

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) halt(); else if (!userPaused) start();
    });

    var rt;
    window.addEventListener('resize', function () {
      clearTimeout(rt);
      rt = setTimeout(function () { measure(); jumpTo(pos); }, 150);
    });

    if (window.Shopify && window.Shopify.designMode) activateReveals(root);

    requestAnimationFrame(function () {
      measure();
      jumpTo(BASE);   // place on the first real card, no animation
      start();        // AUTO-START on load (unless prefers-reduced-motion)
    });
  }

  function initAll() { document.querySelectorAll('.crown-ing').forEach(initCarousel); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector && e.target.querySelector('.crown-ing');
    if (el) { initCarousel(el); activateReveals(el); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["crown-reviews"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('.rvws-carousel').forEach(function (root) {
    if (root.dataset.init) return;
    root.dataset.init = '1';
    var track = root.querySelector('.rvws-track');
    var slides = root.querySelectorAll('.rvws-slide');
    var dots = root.querySelectorAll('[data-rv-dot]');
    var prev = root.querySelector('[data-rv-prev]');
    var next = root.querySelector('[data-rv-next]');
    var count = slides.length;
    if (count <= 1) return;
    var i = 0, timer = null;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var wantsAuto = root.dataset.autoplay === 'true' && !reduce;
    var interval = parseInt(root.dataset.interval, 10) || 6000;

    function go(n) {
      i = (n + count) % count;
      track.style.transform = 'translateX(' + (-i * 100) + '%)';
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
    }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function start() { if (wantsAuto && !timer) { timer = setInterval(function () { go(i + 1); }, interval); } }
    function restart() { stop(); start(); }

    if (prev) prev.addEventListener('click', function () { go(i - 1); restart(); });
    if (next) next.addEventListener('click', function () { go(i + 1); restart(); });
    dots.forEach(function (d) {
      d.addEventListener('click', function () { go(parseInt(d.getAttribute('data-rv-dot'), 10)); restart(); });
    });
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    go(0);
    start();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
